import { environment } from "../../environments/environment";

export class ApiUtils {
    public static get apiUrl(): string {
        return environment.apiUrl;
    }

    public static get identityUrl(): string {
        return environment.identityUrl;
    }

    public static get userApiUrl(): string {
        return environment.userApiUrl;
    }

    public static buildUrl(route: string, args?: Map<string, string>): string {
        let finalRoute: string = route;

        if (args) {
            for (const [key, value] of args) {
                finalRoute = finalRoute.replace(`{${key}}`, value);
            }
        }

        return this.getUrl(ApiType.Default) + finalRoute;
    }

    public static buildIdentityUrl(route: string, args?: Map<string, string>): string {
        let finalRoute: string = route;

        if (args) {
            for (const [key, value] of args) {
                finalRoute = finalRoute.replace(`{${key}}`, value);
            }
        }

        return this.getUrl(ApiType.Identity) + finalRoute;
    }

    public static buildUserUrl(route: string, args?: Map<string, string>): string {
        let finalRoute: string = route;

        if (args) {
            for (const [key, value] of args) {
                finalRoute = finalRoute.replace(`{${key}}`, value);
            }
        }

        return this.getUrl(ApiType.User) + finalRoute;
    }

    private static getUrl(type: ApiType): string {
        switch (type) {
            case ApiType.Default:
                return this.apiUrl;
            case ApiType.Identity:
                return this.identityUrl;
            case ApiType.User:
                return this.userApiUrl;
        }
    }
}

enum ApiType {
    Default,
    Identity,
    User,
}
